export enum SettlementFileNames {
  SOA = 'soa',
}

export enum SettlementFileNamesReadable {
  SOA = 'SOA',
}
